<template>
    <div class="font-semibold items-center justify-center" :style="style">
        <div
            class="absolute inset-0 rounded-full shadow-[inset_0px_2px_4px_0px_rgba(0,0,0,0.05)]"
            v-if="elevated"
        />
        <span class="relative" v-if="!isImage">{{ userInitials }}</span>
    </div>
</template>

<script>
    import colors from '../../../tailwind.colors.mjs';

    export default {
        name: 'ActivixAvatar',

        props: {
            username: {
                type: String,
            },
            initials: {
                type: String,
            },
            initialsLength: {
                type: Number,
                default: 2,
            },
            backgroundColor: {
                type: String,
                default: colors['grey-200'],
            },
            fontSize: {
                type: Number,
                default: 0,
            },
            gradient: {
                type: String,
                default: '',
            },
            elevated: {
                type: Boolean,
                default: false,
            },
            color: {
                type: String,
                default: colors['grey-600'],
            },
            inline: {
                type: Boolean,
            },
            size: {
                type: Number,
                default: 50,
            },
            src: {
                type: String,
            },
        },

        computed: {
            isImage() {
                return !!this.src;
            },

            style() {
                const imgBackgroundAndFontStyle = {
                    background: `transparent url('${this.src}') no-repeat scroll 0% 0% / ${this.size}px ${this.size}px content-box border-box`,
                };

                const computedFontSize = this.fontSize || Math.floor(this.size / 2);
                const initialBackgroundAndFontStyle = this.gradient
                    ? {
                          background: this.gradient,
                          fontSize: `${computedFontSize}px`,
                          color: this.color,
                      }
                    : {
                          backgroundColor: this.backgroundColor,
                          fontSize: `${computedFontSize}px`,
                          color: this.color,
                      };

                const backgroundAndFontStyle = this.isImage
                    ? imgBackgroundAndFontStyle
                    : initialBackgroundAndFontStyle;

                return {
                    ...{
                        display: this.inline ? 'inline-flex' : 'flex',
                        width: `${this.size}px`,
                        height: `${this.size}px`,
                        position: this.elevated ? 'relative' : undefined,
                    },
                    ...backgroundAndFontStyle,
                };
            },

            userInitials() {
                if (this.isImage) {
                    return '';
                }

                return this.initials || this.getInitials(this.username) || '?';
            },
        },

        methods: {
            getInitials(username) {
                if (!username) {
                    return '';
                }

                const parts = username.split(/[ -]/);
                let initials = '';

                for (let i = 0; i < parts.length; i++) {
                    initials += parts[i].charAt(0);
                }

                if (initials.length > this.initialsLength && initials.search(/[A-Z]/) !== -1) {
                    initials = initials.replace(/[a-z]+/g, '');
                }

                return initials.substr(0, this.initialsLength).toUpperCase();
            },
        },
    };
</script>
